import { ADD_LOADER, INIT, REMOVE_LOADER } from '../types';

export default (state = [INIT], action) => {
  switch (action.type) {
    case ADD_LOADER:
      return [...state, action.payload];
    case REMOVE_LOADER:
      return action.payload ? state.filter(item => item !== action.payload) : [];
    default:
      return state;
  }
};
